import { useMutation } from '@tanstack/react-query';
import type {
  DisableTwoFactorIdentityRequestDto,
  DisableTwoFactorIdentityResponseDto,
} from '../types';
import { disableTwoFactorIdentity } from '../requests';

const useTwoFactorDisable = ({
  onSuccess,
}: {
  onSuccess: (data: DisableTwoFactorIdentityResponseDto) => void;
}) => {
  const mutation = useMutation({
    mutationFn: (data: DisableTwoFactorIdentityRequestDto) => {
      return disableTwoFactorIdentity(data.twoFA.identityType, data);
    },
    onSuccess,
  });

  return {
    disableTwoFactorData: mutation.data,
    disableTwoFactor: mutation.mutateAsync,
    isDisableTwoFactorLoading: mutation.isPending,
    isSuccess: mutation.isSuccess,
    isDisableTwoFactorError: mutation.isError,
    disableTwoFactorError: mutation.error,
    resetDisableTwoFactor: mutation.reset,
    mutation,
  };
};

export { useTwoFactorDisable };
